export enum MarginExpenseTypesAttributes {
    IsBillable = 1,
    RoundTripFlights = 2,
    DailyCost = 3,
    Days = 4,
    Amount = 5,
    Specification = 6,
    Recipient = 7,
    Cadence = 8,
    TotalCost = 9,
    ExpenseCap = 10,
    Nights = 11,
    NightlyCost = 12,
    ExpenseAs = 13,
    Designation = 14
}
